import React from 'react';
import { ChevronRight } from 'lucide-react';

const Banner = ({ title, text }) => {
    return (
        <section className="w-full bg-[#FFFFFF] pb-[50px]">
            <div className="max-w-[1440px] mx-auto w-full lg:px-[80px] px-[20px]">
                <div className="py-[56px] lg:px-[46px] px-[20px] relative overflow-hidden flex flex-col md:flex-row bg-transparent">
                    <div className="absolute inset-0 z-0 w-full h-full pointer-events-none">
                        <img
                            src="/assets/banner.png"
                            alt="Background Grid"
                            className="w-full h-full object-cover"
                        />
                    </div>
                    <div className="w-full md:max-w-[577px] px-6 py-12  flex flex-col justify-center relative z-20 text-left">
                        <h2 className="font-sora text-[20px] lg:text-[30px] font-[600] text-white leading-[1.15] mb-6 tracking-tight">
                            {title}
                        </h2>

                        <p className="text-white text-[14px] lg:text-[16px] font-graphik font-[500] leading-relaxed mb-10 max-w-[480px]">
                            More than just a service provider, we work alongside our clients helping them improve processes, solve problems, and build systems that continue to deliver value over time.
                        </p>

                        <div className="flex flex-wrap items-center gap-6">
                            <a
                                href="/contact"
                                className="text-[14px] sm:text-[16px] pb-[10px] border-b border-white font-graphik font-[500] text-white decoration-white flex items-center gap-[18px]"
                            >
                                Talk to an Expert
                                <img src="/assets/nav/white-logo.svg" alt="" />
                            </a>
                        </div>
                        {/* <a
                            href="/contact"
                            className="group inline-flex font-graphik underline items-center gap-2 text-white  pb-0.5 font-[600] text-[14px] lg:text-[16px] hover:text-orange-400 hover:border-orange-400 transition-all duration-300 w-fit"
                        >
                            <span>Talk to an Expert</span>
                            <img src="/assets/arrow.svg" alt="" />
                        </a> */}
                    </div>

                </div>
            </div>
        </section>
    );
};

export default Banner;